import React, { Fragment } from "react";
import ProductAddToCart from "../productPage/ProductAddToCart";
import { NavLink } from "react-router-dom";
import { globalFileIcon } from "../../../../axiosInstance";
import ReactTooltip from "react-tooltip";
import { useSelector, useDispatch } from "react-redux";
import { setUserEntry } from "../../../server/Customer";
import Detailes from "./cardDeailes";

const Card = ({
  element,
  productLocationPopUp,
  productPopUp,
  addToShopListPopUp,
  comparePricesPopUp,
}) => {
  const WeightJump = element.weightJump > 0 ? element.weightJump : 1;
  const dispatch = useDispatch();

  const role = useSelector((state) => state.user.role);
  const user = useSelector((state) => state.user.user);
  console.log("element in card:", element, role);

  const inCart = useSelector((state) =>
    state.productsInCart.productsInCart.find(
      (item) => item.productId === element.productId
    )
  );

  const AddToShopListIfUser = () => {
    if (!user || user.UserTypeId === 5) {
      dispatch(setUserEntry([true, "login"]));
    } else {
      addToShopListPopUp();
    }
  };

  return (
    <Fragment>
      <div className={role ? "item-card role" : "item-card"}>
        {element.weightJump > 1 && (
          <span className="sales-jump tag">
            נמכר ב-{element.weightJump} יחידות
          </span>
        )}

        <div className="top-card-section">
          {role ? (
            element.availability["availableQuantity"] >= WeightJump ? (
              <div
                className="location"
                onClick={() => productLocationPopUp(element)}
              >
                <button
                  className={`inventory ${
                    element.ViewOutOfStockId === 2 ? "red" : "gray"
                  }`}
                  data-tip
                  data-for="registerTipLocation"
                >
                  {element.availability["availableQuantity"]}
                </button>
              </div>
            ) : element.ViewOutOfStockId === 2 ? (
              <div className="location" onClick={productLocationPopUp}>
                <button
                  className="inventory red"
                  data-tip
                  data-for="registerTipLocation"
                >
                  X
                </button>
              </div>
            ) : (
              <div
                className="location"
                onClick={() => productLocationPopUp(element)}
              >
                <button
                  className="inventoryEnd-btn"
                  data-tip
                  data-for="registerTipLocation"
                >
                  חסר
                </button>
              </div>
            )
          ) : element.availability["availableQuantity"] === 0 ? (
            <p className="inventoryEnd">חסר</p>
          ) : null}

          {role && (
            <div className="edit-prod-cls">
              <NavLink
                to={"/edit-product/" + element.productId}
                data-tip
                data-for="registerTipDefinition"
              >
                <img
                  loading="lazy"
                  src={globalFileIcon + "gear.svg"}
                  alt="gear"
                />
              </NavLink>
            </div>
          )}
        </div>

        <ReactTooltip id="registerTipLocation" place="top" effect="solid">
          לחץ כדי לראות מיקום.
        </ReactTooltip>

        <Detailes
          element={element}
          inCart={inCart}
          productPopUp={productPopUp}
          comparePricesPopUp={comparePricesPopUp}
        />

        <div className="details">
          {element.DisableProductId > 1 && element.DisableProductId !== 6 && (
            <p className="inventoryEnd disable-product">
              {element.DisableProduct}
            </p>
          )}

          {element.DisableProductId === 6 && role && (
            <p className="inventoryEnd disable-product">
              {element.DisableProduct}
            </p>
          )}

          <ReactTooltip id="registerTipDefinition" place="top" effect="solid">
            לחץ כדי לעדכן פרטי מוצר.
          </ReactTooltip>
        </div>

        <div className="add-btn">
          <ProductAddToCart element={element} haveInfo={true} />

          {!role ? (
            <img
              loading="lazy"
              className="add-to-list"
              src={globalFileIcon + "listInMemu.svg"}
              alt="list"
              onClick={AddToShopListIfUser}
              data-tip
              data-for="registerTipAddToList"
            />
          ) : null}
        </div>

        <ReactTooltip id="registerTipAddToList" place="top" effect="solid">
          הוסף לרשימת קניות
        </ReactTooltip>
      </div>
    </Fragment>
  );
};

export default Card;
